import { createFileRoute, useNavigate, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { VariantStep } from '../features/rsvp/steps/VariantStep';
import { PageShell } from '../features/rsvp/PageShell';
import { useRsvpFlow } from '../features/rsvp/useRsvpFlow';
import { groupByFighter } from '../features/rsvp/lib/characters';

const Search = z.object({
  fighter: z.string().catch(''),
});

export const Route = createFileRoute('/rsvp/variant')({
  validateSearch: Search.parse,
  beforeLoad: async () => {
    throw redirect({ to: '/' });
  },
  component: VariantPage,
});

function VariantPage() {
  const navigate = useNavigate();
  const { fighter } = Route.useSearch();
  const f = useRsvpFlow();

  if (!f.draft.child_name || !fighter) return null;

  const fighterMap = groupByFighter(f.pickerCharacters);
  const variants = Array.from(fighterMap.get(fighter) ?? []).sort((a, b) =>
    (a.variant ?? '').localeCompare(b.variant ?? ''),
  );

  return (
    <PageShell globalError={f.globalError}>
      <VariantStep
        fighterName={fighter}
        variants={variants}
        selectedId={f.draft.character_id}
        submitting={f.submitting}
        onSelect={(id) => f.setDraft({ ...f.draft, character_id: id })}
        onBack={() => navigate({ to: '/rsvp/fighter' })}
        onContinue={async (id) => {
          if (await f.commitDraft({ character_id: id }))
            navigate({ to: '/rsvp/roster', replace: true });
        }}
      />
    </PageShell>
  );
}
